import PageContainerBlank from '../../components/PageContainer/PageContainerBlank';
import PageEndBlank from '../../components/PageContainer/PageEndBlank';
import FlexPair from '../../components/FlexPair/FlexPair';

const Join = () => {
	const hnsRequirements = (
		<div>
			<p>A few requirements must be met to become a member of the Holy Name Society:</p>
			<ol>
				<li>Be a practicing Catholic man</li>
				<li>Be at least 18 years of age</li>
				<li>Recite the below Holy Name pledge at an induction ceremony</li>
				<li>Pay your $10 annual dues</li>
			</ol>
		</div>
	);
	const mailImage = (
		<a href="/static/documents/HolyNameApplication.pdf" target="_blank" style={{ textAlign: 'center' }}>
			<img src="/static/images/join/MailApplication.png" alt="Holy Name Application" style={{ maxWidth: '60%' }} />
		</a>
	);
	return (
		<div>
			<PageContainerBlank />

			<h1>Joining the Holy Name Society</h1>
			<FlexPair leftContent={hnsRequirements} rightContent={mailImage} />
			<p className="justify">
				See our <a href="/upcoming_events">Events Calendar</a> to figure out when the next Holy Name meeting or induction ceremony is.
				Click the application image above to see a printable Holy Name handout (membership application included on page 3).
				An application may be submitted to the St. Joseph Parish office or a Holy Name officer.
			</p>
			<p>You can also <a href="mailto:hanoverholyname@gmail.com">email us</a> here with any questions you may have: <a href="mailto:hanoverholyname@gmail.com">hanoverholyname@gmail.com</a></p>
			<br />

			<h2>Holy Name Pledge</h2>
			<p className="pledge-text">
				Blessed be God.<br />
				Blessed be His Holy Name.<br />
				Blessed be Jesus Christ, true God and true man.<br />
				Blessed be the Name of Jesus.<br />
				<br />
				I believe, O Jesus, that Thou art the Christ&mdash;<br />
				<span className="tab"></span>the Son of the Living God.<br />
				<br />
				I proclaim my love for the Vicar of Christ on Earth.<br />
				<br />
				I believe all the sacred truths<br />
				<span className="tab"></span>which the Holy Catholic Church<br />
				<span className="tab"></span>believes and teaches.<br />
				<br />
				I promise to give good example<br />
				<span className="tab"></span>by the regular practice<br />
				<span className="tab"></span>of my faith.<br />
				<br />
				In honor of His Divine Name,<br />
				<span className="tab"></span>I pledge myself against perjury,<br />
				<span className="tab"></span>blasphemy,<br />
				<span className="tab"></span>profanity,<br />
				<span className="tab"></span>and obscene speech.<br />
				<br />
				I pledge my loyalty<br />
				<span className="tab"></span>to the flag of my country,<br />
				<span className="tab"></span>and to the God-given principles<br />
				<span className="tab"></span>of freedom, justice, and happiness<br />
				<span className="tab"></span>for which it stands.<br />
				<br />
				I pledge my support<br />
				<span className="tab"></span>to all lawful authority<br />
				<span className="tab"></span>both civil and religious.<br />
				<br />
				I dedicate myself to the honor of the Sacred Name of Jesus Christ<br />
				<span className="tab"></span>and beg that He will keep me faithful to these pledges until death.<br />
				<br />
				Amen.<br />
			</p>

			<PageEndBlank />
		</div>
	);
};

export default Join;